import { canonicalSlug, MODEL_DETAILS } from '../components/configurator/catalog';
import { pieceSlug } from '../lib/characters';
import { isMadeToOrder } from './orderPresentation';

export function cartQuantity(item, quantity) {
  const value = Number(quantity);
  if (!Number.isSafeInteger(value) || value < 1) return null;
  return isMadeToOrder(item) ? value : 1;
}

export function restoreCart(stored) {
  if (!Array.isArray(stored)) return [];
  const result = [];
  for (const item of stored) {
    if (!item || typeof item.slug !== 'string' || !item.slug || typeof item.name !== 'string'
      || typeof item.price !== 'number' || !Number.isFinite(item.price) || item.price < 0) continue;
    const quantity = cartQuantity(item, item.quantity);
    if (!quantity) continue;
    const configuration = item.configuration && typeof item.configuration === 'object'
      ? { ...item.configuration, options: Array.isArray(item.configuration.options) ? item.configuration.options.filter(Boolean) : [] } : null;
    const color = typeof item.color === 'string' ? item.color : '';
    const configurationId = item.configurationId || configuration?.id || null;
    // Chaque pièce a son slug (personnage-variante) : le ramener au personnage commanderait une autre pièce.
    // Un panier enregistré avec ce défaut retrouve sa pièce dans sa clé « {slug de la pièce}-{coloris} ».
    const keyedPiece = !configurationId && !configuration && typeof item.cartKey === 'string' && item.cartKey.endsWith(`-${color}`)
      ? item.cartKey.slice(0, -(color.length + 1)) : '';
    const slug = keyedPiece.startsWith(`${pieceSlug(item.slug)}-`) ? keyedPiece : pieceSlug(item.slug);
    const current = MODEL_DETAILS[canonicalSlug(slug)];
    const cartKey = item.cartKey || (configurationId ? `${slug}-${configurationId}` : `${slug}-${color}`);
    // Chaque pièce du registre est unique : une seule ligne par slug, même avec deux coloris enregistrés.
    if (!isMadeToOrder(item) && result.some(i => i.slug === slug && !isMadeToOrder(i))) continue;
    result.push({ ...item, slug, quantity, color, configuration, configurationId, cartKey,
      image: typeof item.image === 'string' ? item.image : '',
      name: current ? current.name + (configurationId || configuration ? ' sur mesure' : '') : item.name });
  }
  return result;
}

export function removeOrderedItems(items, orderedItems) {
  if (!Array.isArray(orderedItems)) return items;
  const configurationSignature = config => JSON.stringify((Array.isArray(config?.options) ? config.options : [])
    .filter(Boolean).map(option => [option.group || '', option.option_id]).sort((a, b) => a[0].localeCompare(b[0])));
  let remaining = items;
  for (const orderItem of orderedItems) {
    const slug = pieceSlug(orderItem.product_slug || orderItem.slug || '');
    const configId = orderItem.configuration_id || orderItem.configuration?.id || null;
    const index = remaining.findIndex(item => item.slug === slug && (
      configId ? item.configurationId === configId
        : orderItem.configuration ? !item.configurationId && item.configuration
          && configurationSignature(item.configuration) === configurationSignature(orderItem.configuration)
          : !item.configurationId && !item.configuration && item.color === (orderItem.color || '')
    ));
    const quantity = Number(orderItem.quantity);
    if (index < 0 || !Number.isSafeInteger(quantity) || quantity <= 0) continue;
    remaining = remaining.flatMap((item, i) => i !== index ? [item]
      : item.quantity > quantity ? [{ ...item, quantity: item.quantity - quantity }] : []);
  }
  return remaining;
}
